// Section 22 History tab root: charts over the run (population, food, water, wood, tools, trust,
// happiness, fragility, inequality) with event and death markers, and the season-by-season
// report archive with the factor lists stored in the reports.
import { game } from '../../store';
import { historyVM } from '../../viewModels';
import { uiText } from '../text/en';
import { Archive } from './archive';
import { Charts } from './charts';
import './history.css';

export function HistoryTab() {
  const g = game.value;
  if (g === null) return null;
  const vm = historyVM(g);
  const t = uiText.history;
  if (vm.seasons === 0) return <p class="hint">{t.empty}</p>;
  return (
    <div class="history">
      <Charts vm={vm} />
      <Archive vm={vm} />
    </div>
  );
}
